module.exports = __webpack_public_path__ + "img/ig-verify-1.c15efe5d.svg";